import React from 'react';
import { FormattedMessage } from 'react-intl';

import { TrlPillContainer, TrlPillLabel } from '../TrlPill.styles';
import {
  TrlPillDotStyled,
  TrlPillPendingStyled,
} from './TrlPillPending.styles';

export const TrlPillPending = () => {
  return (
    <TrlPillContainer>
      <TrlPillPendingStyled
        label={
          <>
            <TrlPillDotStyled />
            <TrlPillDotStyled />
            <TrlPillDotStyled />
          </>
        }
      />
      <TrlPillLabel>
        <FormattedMessage id="TRLT_UI-PENDING" />
      </TrlPillLabel>
    </TrlPillContainer>
  );
};
